import React from "react";

// router
import { useNavigate } from "react-router-dom";

// constant
import { IOpportunity } from "../../../store/@types/opportunity";
import { formatDate } from "../../../service/convert/date";

type IOpportunityCard = {
  item: IOpportunity;
};

const OpportunityCard: React.FC<IOpportunityCard> = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/dashboard/opportunity/${item?.id}`)}
      className="bg-white rounded-xl overflow-hidden shadow-md border border-primary-50/20 transform transition-transform duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
    >
      <div>
        <img
          src={item?.opportunity_image}
          alt={item?.opportunity_name}
          className="w-full h-48 object-cover"
        />
      </div>
      <div className="p-6">
        <div className="mb-3 flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-900 underline">
            Expiry Date:
          </span>
          <span className="text-xs font-semibold text-gray-900">
            {formatDate(item?.expire_date)}
          </span>
        </div>
        <h2 className="text-sm lg:text-lg font-medium text-gray-900 mb-2 line-clamp-2 hover:text-blue-600 transition-colors duration-200">
          {item?.opportunity_name}
        </h2>
      </div>
    </div>
  );
};

export default OpportunityCard;
